import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './Navbar';
import HomePage from './HomePage';
import CategoryPage from './CategoryPage';
import ImportPage from './ImportPage';
import './App.css';
import AuditLogPage from './AuditLogPage';
import UsersPage from './UsersPage';
import SetupAccountPage from './SetupAccountPage';
import LoginPage from './LoginPage';
import { ToastProvider } from './ToastContext';
import ForgotPasswordPage from './ForgotPasswordPage';

function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/category/:categoryId" element={<CategoryPage />} />
          <Route path="/import" element={<ImportPage />} />
          <Route path="/admin/users" element={<UsersPage />} />
          <Route path="/admin/audit-log" element={<AuditLogPage />} />
          <Route path="/setup-account" element={<SetupAccountPage />} />
          <Route path="/admin" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;